import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "24_other-app.svg",
  "use": "24_other-app.svg-usage",
  "viewBox": "0 0 24 25.15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25.15\" id=\"24_other-app.svg\"><rect width=\"24\" height=\"24\" style=\"fill:none\" /><rect x=\"1\" y=\"1\" width=\"22\" height=\"22\" rx=\"3\" style=\"fill:#00ad56\" /><text transform=\"translate(4.93 15.8)\" style=\"font-size:11px;fill:#fff;font-family:SegoeWP-Bold, Segoe WP;font-weight:700\"><tspan style=\"letter-spacing:-0.05908203125em\">P</tspan><tspan x=\"6.11\" y=\"0\">A</tspan></text></symbol>"
});
var result = sprite.add(symbol);
export default symbol